import Service from "../AuthService";

const RejectReason = {
    RejectReason() {
        return Service.get(`reject-reason`);
    }
};

export default RejectReason;
